import { useTranslation } from 'react-i18next';
import { XIcon } from 'lucide-react';
import EmptyIcon from '@/shared/assets/empty-icon.svg?react';

type Props = {
  onReset: () => void;
};

const SearchNotFound = ({ onReset }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex grow flex-col items-center justify-center gap-[1.6rem] p-[2.4rem] text-center">
      <EmptyIcon className="size-[4rem] text-secondary" />

      <div className="flex flex-col gap-[0.4rem]">
        <span className="headline4 text-primary">
          {t('personalAccount.globalSearch.notFound.title')}
        </span>
        <span className="p4 text-secondary">
          {t('personalAccount.globalSearch.notFound.description')}
        </span>
      </div>

      <button
        type="button"
        onClick={onReset}
        className="flex h-[3.2rem] items-center gap-[0.6rem] px-[1.6rem] rounded-full bg-secondary-bg medium6 text-primary cursor-pointer hover:bg-stroke transition-colors">
        <XIcon className="size-[1.4rem]" />
        {t('personalAccount.globalSearch.notFound.reset')}
      </button>
    </div>
  );
};

export { SearchNotFound };
